const mapDateTime = (dateTime) => new Date(dateTime);

export default mapDateTime;
